import { render, staticRenderFns } from "./ThoughtsPage.vue?vue&type=template&id=db8bacfc&scoped=true"
import script from "./ThoughtsPage.vue?vue&type=script&lang=js"
export * from "./ThoughtsPage.vue?vue&type=script&lang=js"
import style0 from "./ThoughtsPage.vue?vue&type=style&index=0&id=db8bacfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bacfc",
  null
  
)

export default component.exports